import Vue from 'vue'

import {Current} from '../../interface'
import types from '../types'

const state: {
  list: Current[],
  selected: number
} = {
  list: [],
  selected: -1
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.mutations.BADGE_LIST_INIT](state: any): void {
    Vue.set(state, 'list', [])
    Vue.set(state, 'selected', -1)
  },
  [types.mutations.BADGE_LIST_ADD](state: any, current: Current): void {
    const list: Current[] = state.list
    current.isNew = false
    list.push({...current})

    Vue.set(state, 'list', list)
  },
  [types.mutations.BADGE_LIST_UPDATE](state: any, current: Current): void {
    const list: Current[] = state.list
    const index = state.selected

    if (! list[index]) {
      return
    }

    current.isNew = false
    list[index] = {...current}

    Vue.set(state, 'list', list)
  },
  [types.mutations.BADGE_LIST_DELETE](state: any, index: number): void {
    const list: Current[] = state.list.filter((n: any, key: number) => key !== index)

    Vue.set(state, 'list', list)
  },
  [types.mutations.BADGE_LIST_SELECTED](state: any, selected: number): void {
    Vue.set(state, 'selected', selected)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
